<template>
  <div class="amazon-left">
    <div class="section-title">参考商品图</div>

    <div class="tab-switch wide" style="margin-bottom: 12px">
      <button class="tab-btn" :class="{ active: workbench.amazon.useCutRef }" @click="workbench.amazon.useCutRef = true">
        抠图结果
      </button>
      <button class="tab-btn" :class="{ active: !workbench.amazon.useCutRef }" @click="workbench.amazon.useCutRef = false">
        本地上传
      </button>
    </div>

    <div class="upload-box" :class="{ active: !workbench.amazon.useCutRef }" @click="!workbench.amazon.useCutRef && fileAmazon?.click()">
      <template v-if="workbench.amazon.useCutRef">
        <template v-if="workbench.lastCut">
          <img :src="workbench.lastCut" class="preview-img" style="object-fit: contain; background: #fff" />
        </template>
        <template v-else>
          <div style="padding: 20px; color: #999">暂无抠图结果<br /><span style="font-size: 12px">请先去“抠图工作台”处理图片</span></div>
        </template>
      </template>

      <template v-else>
        <input ref="fileAmazon" type="file" style="display: none" accept="image/*" @change="onAmazonFile" />

        <template v-if="workbench.amazon.localPreview">
          <img :src="workbench.amazon.localPreview" class="preview-img" style="object-fit: contain" />
          <div class="upload-tip">点击更换图片</div>
        </template>
        <template v-else>
          <div class="upload-plus">+</div>
          <div class="upload-tip">点击上传图片</div>
        </template>
      </template>
    </div>

    <div class="config-section" style="margin-top: 20px">
      <div class="section-row">
        <label class="section-label">补充信息 (可选)</label>
      </div>
      <textarea
        v-model="workbench.amazon.extraContext"
        class="section-textarea"
        placeholder="例如：品牌名是Zeus，核心材质是304不锈钢，适用人群是登山爱好者..."
        rows="4"
      ></textarea>

      <button class="primary-btn" :disabled="workbench.amazon.loading" style="margin-top: 20px" @click="onGenerate">
        {{ workbench.amazon.loading ? 'AI 撰写中...' : '生成英文文案' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
const fileAmazon = ref(null)

const onAmazonFile = async (event) => {
  const file = event.target.files?.[0]
  if (!file) {
    return
  }
  await workbench.setAmazonFile(file)
  event.target.value = ''
}

const onGenerate = async () => {
  try {
    await workbench.generateAmazonCopy()
  } catch (error) {
    alert(error.message)
  }
}
</script>
